import { useEffect, useState } from 'react';
import { Menu, MenuProps } from 'antd';
import { useAuth } from '../../Contexts/AuthContext';
import { TextService } from '../../Services/TextService';
import { UserOutlined, TeamOutlined, UserAddOutlined, BarChartOutlined, PictureOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { getCurrentLanguage } from '../../Helpers/RouteHelper';
import { CompanyRole } from '../../Types/CompanyRole';

const LeftMenuCommunicate = (props: any) => {
    const [current, setCurrent] = useState('1');
    const { user } = useAuth();
    const GetText = TextService.GetText;
    const navigation = useNavigate();
    useEffect(() => {
        setCurrent(props.selected);
    }, []);

    type MenuItem = Required<MenuProps>['items'][number];

    const onClick: MenuProps['onClick'] = (e: any) => {
        navigation("/" + getCurrentLanguage() + "/" + e.key);
    };

    function getItem(
        label: React.ReactNode,
        key?: React.Key | null,
        icon?: React.ReactNode,
        children?: MenuItem[],
        type?: 'group',
    ): MenuItem {
        return {
            key,
            icon,
            children,
            label,
            type,
        } as MenuItem;
    }

    const sendMailItems: MenuItem[] = [
        getItem(GetText("Communicate_SendCategoryTitle"), 'sendEmail', <TeamOutlined />),
        getItem(GetText("Communicate_SendMemberTitle"), 'sendEmailUser', <UserOutlined />),
        getItem(GetText("Communicate_SendExternalTitle"), 'sendEmailExternal', <UserAddOutlined />),
    ];

    const sendSmsItems: MenuItem[] = [
        getItem(GetText("Communicate_SendCategoryTitle"), 'sendSms', <TeamOutlined />),
        getItem(GetText("Communicate_SendMemberTitle"), 'sendSmsUser', <UserOutlined />),
        getItem(GetText("Communicate_SendExternalTitle"), 'sendSmsExternal', <UserAddOutlined />),
    ];

    const items: MenuItem[] = user?.role == CompanyRole.GlobalAdmin ? [
        getItem(GetText("Communicate_SendMailTitle"), 'sendSmsHeader', <TeamOutlined />, sendMailItems, "group"),
        getItem(GetText("Communicate_SendSmsTitle"), 'sendSmsUserHeader', <TeamOutlined />, sendSmsItems, "group"),
        { ...getItem('E-post/sms uppföljning', 'emailFollowUp', <BarChartOutlined />), style: { paddingLeft: '8px' } } as MenuItem,
        { ...getItem(GetText("PictureArchive_Title"), 'picturearchive', <PictureOutlined />), style: { paddingLeft: '8px' } } as MenuItem,

    ] : [
    ];

    return <Menu
        theme="light"
        onClick={onClick}
        defaultOpenKeys={['sendSmsHeader', 'sendSmsHeader']}
        inlineCollapsed={false}
        selectedKeys={[current]}
        mode="inline"
        items={items}
        disabledOverflow={true}
    />
};

export default LeftMenuCommunicate;